import { BehaviorSubject, Observable, of } from 'rxjs';
import {
  CellItemType,
  Constants,
  PaymentData,
  PaymentSearchParameters
} from '@benefitsui/app/pages/billing-page/billing-page.types';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { SearchSortDirection, SearchSortField } from '@benefitsui/app/api/benefits-clients';
import { Defaults } from '@benefitsui/app/shared/defaults/defaults';

@Injectable({
  providedIn: 'root'
})
export class BillingService {
  screenName$ = new BehaviorSubject<string>('list');
  private paymentTableCells: PaymentData[] = [];
  premiumInvoiceData: CellItemType | undefined;
  totalAmount = 0;
  clearCache = false;
  refreshCache = false;

  setInvoiceData(invoiceInfo: CellItemType): void {
    this.premiumInvoiceData = invoiceInfo;
  }

  getPaymentTableCells(): PaymentData[] {
    return this.paymentTableCells;
  }

  setPayment(tableCells: CellItemType[]): void {
    this.paymentTableCells = [];
    this.paymentTableCells = tableCells.map((x) => {
      const paymentData = {
        Amount: x.amount,
        AmountUi: x.amountUI,
        AmountUiError: false,
        BillGroupNumber: x.billGroupNumber,
        BillGroupName: x.billGroupName,
        Invoice: x.invoice,
        InvoiceNumber: x.invoiceNumber,
        InvoicePeriod: x.invoicePeriod,
        InvoiceFrom: x.invoicePeriod.from
      } as PaymentData;

      return paymentData;
    });
  }

  setTotalAmount(totalAmount: number): void {
    this.totalAmount = totalAmount;
  }

  setClearCache(clearCache: boolean): void {
    this.clearCache = clearCache;
  }

  setRefreshCache(refreshCache: boolean): void {
    this.refreshCache = refreshCache;
  }
  formatAmount(amountString: string | undefined): string {
    const currencyPipe = new CurrencyPipe(Defaults.usLocale);
    const numberString = this.getNumberString(amountString ?? Constants.StringEmpty);
    const currencyString = currencyPipe.transform(numberString) ?? Constants.StringEmpty;

    if (amountString === Constants.StringEmpty) {
      return Constants.StringEmpty;
    } else if (amountString?.includes('Estimated')) {
      return 'Estimated ' + currencyString;
    } else {
      return currencyString;
    }
  }

  getAmountNumber(amountString: string): number {
    const numberString = this.getNumberString(amountString);
    const numberValue = +numberString;
    return numberValue;
  }

  getNumberString(amountString: string): string {
    const numberString = amountString.replace(/[^.0-9]/g, Constants.StringEmpty);
    return numberString;
  }

  getAction(runDate: string, premiumId: string, type: string) {
    if (premiumId === '') {
      return 'Not available';
    }
    if (type === 'SA') {
      const formattedDate = new Date(runDate);
      const today = new Date();
      const todayDate = today.getDate();
      const todayMonth = today.getMonth();
      const todayYear = today.getFullYear();
      const pastDate = new Date(todayYear - 2, todayMonth, todayDate);
      return formattedDate >= pastDate ? 'Calculate premium' : 'View premium calculation';
    } else {
      return Constants.StringEmpty;
    }
  }

  formatDate(dateString: string | undefined): string | null {
    const datePipe = new DatePipe(Defaults.usLocale);
    if (dateString === Constants.StringEmpty || dateString === null) return dateString;
    else return datePipe.transform(dateString, Defaults.dateFormatString);
  }

  totalPaymentLines = 0;
  setTotalPaymentLines(totalPaymentLines: number): void {
    this.totalPaymentLines = totalPaymentLines;
  }

  getPaymentLines(parameters: PaymentSearchParameters): Observable<PaymentData[]> {
    const sortOrder = parameters.sortDirection === SearchSortDirection.Ascending ? 'asc' : 'desc';
    const sortField = parameters.sortField === SearchSortField.Invoice ? 'InvoiceFrom' : parameters.sortField;  
    let tableData = _.orderBy(this.paymentTableCells, sortField, [sortOrder]);
    if(parameters.sortField === SearchSortField.Invoice){
      tableData = _.orderBy(this.paymentTableCells, [sortField, 'InvoiceNumber'], [sortOrder, sortOrder]);
    }
    const offset = (parameters.page - 1) * parameters.pageSize;
    const pagedItems = _.drop(tableData, offset).slice(0, parameters.pageSize);

    return of(pagedItems);
  }
}
